module.exports = __webpack_public_path__ + "static/img/tu22.979d539.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/tu22.png
// module id = 4rAE
// module chunks = 1